import { SB } from '@play-co/replicant';

export const minigameSchema = {
  minigame: SB.object({
    minigameCount: SB.number().min(0).default(0),
    minigameShown: SB.boolean().default(false),
    currentMinigame: SB.string().optional(),
    lastStartedAt: SB.number(),
    eventId: SB.string().optional(),
    multiplier: SB.number().min(1).default(1),
    totalPointsEarned: SB.map(SB.number().min(0)),

    /**
     * @deprecated
     */
    frenzyPointsEarned: SB.object({
      eventId: SB.string(),
      points: SB.number().min(0),
    }).optional(),
    currentLevel: SB.number().min(1).default(1).optional(),
    continues: SB.number().min(0).default(0).optional(),
    boosters: SB.map(SB.number().min(0).default(0)).optional(),
  }).optional(),
};
